<!-- OTP Verification -->
<div *ngIf="!isEmailVerified" class="auth-panel flex flex-col gap-6">
  <div class="flex items-center justify-center">
    <span class="auth-title">OTP Verification</span>
  </div>

  <p class="text-center text-sm text-gray-600 -mt-2">
    Enter the 6-digit code sent to your email
  </p>

  <div [formGroup]="otpForm" class="flex flex-col gap-5">
    <div class="flex gap-2 sm:gap-3 items-center justify-center w-full">
      <ng-container *ngFor="let i of [0,1,2,3,4,5]">
        <input
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-input"
          [formControl]="getOtpControl(i)"
          (input)="onOtpInput($event, i)"
        />
      </ng-container>
    </div>

    <div class="auth-submit-wrap">
      <app-primary-button (click)="submitOtp()">
        <div class="gap-2 flex items-center justify-center">
          <img src="../../assets/image/Shape.png" alt="" class="h-4" />
          Verify
        </div>
      </app-primary-button>
    </div>

    <div class="w-full items-center justify-center flex">
      <button type="button" class="text-sm text-primary font-medium hover:underline" (click)="resendOtp()">
        Resend OTP?
      </button>
    </div>
  </div>
</div>

<!-- Set Password -->
<div *ngIf="isEmailVerified" class="auth-panel flex flex-col gap-6">
  <div class="flex items-center justify-center">
    <span class="auth-title">Set Password</span>
  </div>

  <p class="text-center text-sm text-gray-600 -mt-2">
    Create a secure password for your organization account
  </p>

  <form [formGroup]="passwordForm" class="flex flex-col gap-5" (ngSubmit)="submitPassword()">
    <div class="relative w-full">
      <label class="auth-field-label" for="set-password">Password</label>
      <div class="relative">
        <input
          id="set-password"
          class="auth-input"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Enter password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
        >
          <img
            [src]="showPassword ? '../../assets/image/eye.svg' : '../../assets/image/closeeye.svg'"
            alt=""
            class="w-5 h-5 opacity-70"
          />
        </button>
      </div>
      <p class="auth-hint">
        At least 8 characters with uppercase, lowercase, number, and special character.
      </p>
      <div class="auth-error" *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid">
        <p *ngIf="passwordForm.get('password')?.errors?.['required']">Password is required.</p>
        <p *ngIf="passwordForm.get('password')?.errors?.['pattern'] || passwordForm.get('password')?.errors?.['minlength']">
          Password must meet the requirements above.
        </p>
      </div>
    </div>

    <div class="relative w-full">
      <label class="auth-field-label" for="confirm-password">Confirm Password</label>
      <div class="relative">
        <input
          id="confirm-password"
          class="auth-input"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirm_password"
          placeholder="Re-enter password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="password-toggle-btn"
          (click)="showConfirmPassword = !showConfirmPassword"
          [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
        >
          <img
            [src]="showConfirmPassword ? '../../assets/image/eye.svg' : '../../assets/image/closeeye.svg'"
            alt=""
            class="w-5 h-5 opacity-70"
          />
        </button>
      </div>
      <div class="auth-error" *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.touched">
        Passwords do not match.
      </div>
    </div>

    <div class="auth-submit-wrap">
      <app-primary-button type="submit">
        <div class="gap-2 flex items-center justify-center">
          <img src="../../assets/image/Shape.png" alt="" class="h-4" />
          Set Password
        </div>
      </app-primary-button>
    </div>
  </form>
</div>
